import { CSSProperties } from "react";

export type BackgroundStyleInput = {
    backvariant?: "variant_1" | "variant_2" | "variant_3";
    gradient_color_1?: string;
    gradient_color_2?: string;
    gradient_color_3?: string;
    gradient_color_4?: string;
    desktop_background_color?: string;
    mobile_background_color?: string;
};

const toRgba = (color: string, opacity: number) => {
  // If already in rgba format, use it directly
  if (color.startsWith('rgba(')) {
    return color;
  }
  
  // If in rgb format, convert to rgba with the provided opacity
  if (color.startsWith('rgb(')) {
    const rgbMatch = color.match(/rgb\((\d+),\s*(\d+),\s*(\d+)\)/);
    if (rgbMatch) {
      return `rgba(${rgbMatch[1]}, ${rgbMatch[2]}, ${rgbMatch[3]}, ${opacity})`;
    }
  }
  
  // If hex format, convert to rgba
  if (color.startsWith('#')) {
    const r = parseInt(color.slice(1, 3), 16);
    const g = parseInt(color.slice(3, 5), 16);
    const b = parseInt(color.slice(5, 7), 16);
    return `rgba(${r}, ${g}, ${b}, ${opacity})`;
  }
  
  // Fallback: return as is
  return color;
};

export const formatBackgroundStyle = (input: BackgroundStyleInput, isMobile = false, backgroundColor = "#000000"): CSSProperties => {
    const { 
      backvariant, 
      gradient_color_1, 
      gradient_color_2, 
      gradient_color_3, 
      gradient_color_4,
      desktop_background_color,
      mobile_background_color 
    } = input;

    const bg = (isMobile ? mobile_background_color : desktop_background_color) ?? backgroundColor;

    // variant_3: Use solid colors
    if (backvariant === "variant_3") {
      return {
        backgroundColor: bg
      };
    }


    // variant_1: Diagonal gradient from top-left (240.776deg)
    // atleast one gradient color is required
    if (backvariant === "variant_1" && gradient_color_1) {
      return {
        backgroundColor: bg,
        backgroundImage: `linear-gradient(253deg, ${toRgba(gradient_color_1, 0.33)} 0%${
        gradient_color_2 ? `, ${toRgba(gradient_color_2, 0.66)} 24.684%` : ""
        }${
        gradient_color_3 ? `, ${toRgba(gradient_color_3, 0.66)} 79.089%` : ""
        }${
        gradient_color_4 ? `, ${toRgba(gradient_color_4, 0.463)} 100%` : ""
        })`
      };
    }

    // variant_2: Diagonal gradient from bottom-right (-54.3304deg)
    if (backvariant === "variant_2" && gradient_color_1) {
      return {
        backgroundColor: bg,
        backgroundImage: `linear-gradient(292deg, ${toRgba(gradient_color_1, 0.33)} 0%${
        gradient_color_2 ? `, ${toRgba(gradient_color_2, 0.66)} 24.684%` : ""
        }${
        gradient_color_3 ? `, ${toRgba(gradient_color_3, 0.66)} 79.089%` : ""
        }${
        gradient_color_4 ? `, ${toRgba(gradient_color_4, 0.463)} 100%` : ""
        })`
      };
    }

    // Default fallback
    return {
      backgroundColor: bg
    };
  };